// extracted by mini-css-extract-plugin
export default {"title":"U_-z","warning":"V_-z","sizeOptionsLegendText":"W_-z"};